export type DashboardView = "all" | "tmall" | "kuaishou" | "pdd" | "douyin";

const views: Array<{ id: DashboardView; label: string; count: string }> = [
  { id: "all", label: "全部平台", count: "57店" },
  { id: "tmall", label: "天猫", count: "2店" },
  { id: "kuaishou", label: "快手", count: "15店" },
  { id: "pdd", label: "拼多多", count: "6店" },
  { id: "douyin", label: "抖音", count: "34店" },
];

export function DashboardPlatformTabs({
  current,
  onChange,
}: {
  current: DashboardView;
  onChange: (view: DashboardView) => void;
}) {
  return (
    <nav className="dashboardPlatformTabs" aria-label="数据看板平台">
      {views.map((view) => (
        <button
          type="button"
          key={view.id}
          className={current === view.id ? "active" : ""}
          aria-current={current === view.id ? "page" : undefined}
          onClick={() => onChange(view.id)}
        >
          <span>{view.label}</span>
          <small>{view.count}</small>
        </button>
      ))}
    </nav>
  );
}
